import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import {RANKING_SCREEN, SETTINGS_SCREEN, STATISTICS_SCREEN} from '../../ducks/duck-screen'

const iconHighscore = "static/images/main-screen/icon_high_scores.png";
const iconSettings = "static/images/main-screen/icon_options.png";
const iconStats = "static/images/main-screen/icon_stats.png";


const styles = theme => ({
	icon: {
		width: "60px",
	},
	container: {
		padding: "0 5px",
	},
	'@media (max-width: 600px)': {
		icon: {
			width: "50px",
		},
	},
});

function BottomRow(props) {
	const { classes, push } = props;
	const iconWidth = 5;
	return (
		<Grid container spacing={2} wrap="nowrap" direction="row" style={{'justifyContent': 'center'}}>
			<Grid item xs={iconWidth} className={classes.container}>
				<img id="highscore-button" className={classes.icon} src={iconHighscore} alt="Highscore" onClick={e => push(RANKING_SCREEN)}/>
			</Grid>
			<Grid item xs={iconWidth} className={classes.container}>
				<img id="settings-button" className={classes.icon} src={iconSettings} alt="Settings" onClick={e => push(SETTINGS_SCREEN)}/>
			</Grid>
			<Grid item xs={iconWidth} className={classes.container}>
				<img id="statistics-button" className={classes.icon} src={iconStats} alt="Statistics" onClick={e => push(STATISTICS_SCREEN)}/>
			</Grid>
		</Grid>
	);
}

BottomRow.propTypes = {
	classes: PropTypes.shape({
		icon: PropTypes.string.isRequired,
	}).isRequired,

	push: PropTypes.func.isRequired,
};

export default withStyles(styles)(BottomRow);